// extracted by mini-css-extract-plugin
export default {"root":"IconButton_root__FX9qu","icon":"IconButton_icon__pKibD"};